<template>
  <v-simple-table fixed-header height="67vh">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="simple-table-th">Serial Number</th>
          <th class="simple-table-th">Inbond Date</th>
          <th class="simple-table-th">Inbond Doc #</th>
          <th class="simple-table-th">Outbond Date</th>
          <th class="simple-table-th">Outbond #</th>
          <th class="simple-table-th">Created At</th>
        </tr>
      </thead>

      <tbody>
        <!-- DATA ROWS -->
        <template v-if="inventoryData.length">
          <tr
            v-for="(row, index) in inventoryData"
            :key="index"
            :class="{
              'custom-border-top': index === 0,
              'orange_lighten-5': index % 2 === 0,
            }"
          >
            <!-- Serial -->
            <td class="simple-table-td pl-4">
              {{ row.activated }}
              <template v-if="row.text">
                <showBarcode
                  :barcodeUrl="row.barcode_image"
                  :barcode-text="row.text"
                  title="Barcode"
                />
                <span class="mr-1 text-capitalize">{{ row.text }}</span>
              </template>
              <em v-else class="text-muted">no Serial no.</em>
            </td>

            <!-- Inbond Date -->
            <td class="simple-table-td pl-4">
              <template v-if="row.in_bond_date">
                <span
                  class="font-weight-700"
                  :style="{ color: getColor(row.inbond_module_type) }"
                >
                  {{ formatDate(row.in_bond_date) }}
                </span>
              </template>
              <template v-else-if="inbondDate">
                {{ formatDate(inbondDate) }}
              </template>
              <em v-else class="text-muted">no inbond date</em>
            </td>

            <!-- Inbond Doc -->
            <td class="simple-table-td pl-4 text-capitalize">
              <template v-if="row.inbond_barcode">
                <Barcode
                  :barcode="row.inbond_barcode"
                  :route="getRoute(row.inbond_module_type)"
                  :id="row.inbond_id"
                  :color="getColor(row.inbond_module_type)"
                />
              </template>
              <em v-else class="text-muted">no inbond doc</em>
            </td>

            <!-- Outbond Date -->
            <td class="simple-table-td pl-4">
              <template v-if="row.out_bond_date">
                <span
                  class="font-weight-700"
                  :style="{ color: getColor(row.outbond_module_type) }"
                >
                  {{ formatDate(row.out_bond_date) }}
                </span>
              </template>
              <em v-else class="text-muted">no outbond date</em>
            </td>

            <!-- Outbond Doc -->
            <td class="simple-table-td pl-4">
              <template
                v-if="row?.outbond_barcode"
              >
                <Barcode
                  :barcode="row.outbond_barcode"
                  :route="getRoute(row.outbond_module_type)"
                  :id="row.outbond_id"
                  :color="getColor(row.outbond_module_type)"
                />
              </template>
              <em v-else class="text-muted">no outbond no</em>
            </td>

            <!-- Created -->
            <td class="simple-table-td pl-4">
              <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                <template #display_name>
                  {{ row.added_by?.display_name }}
                </template>
                <template #date_time>
                  {{ formatDateTime(row.added_at) }}
                </template>
                <template #format_date_time>
                  {{ formatDate(row.added_at) }}
                  {{ formatTime(row.added_at) }}
                </template>
              </TableActivity>
            </td>
          </tr>
        </template>

        <!-- LOADING -->
        <template v-else-if="loading">
          <tr v-for="n in 3" :key="n">
            <td v-for="i in 6" :key="i">
              <v-skeleton-loader
                type="text"
                class="custom-skeleton table-rows-text"
              />
            </td>
          </tr>
        </template>

        <!-- EMPTY -->
        <tr v-else>
          <td colspan="6" class="text-center font-weight-500 font-size-16">
            <img
              :src="$assetURL('media/error/empty.png')"
              class="row-not-found-image"
            />
            Uhh... There are no records at the moment.
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import showBarcode from "@/view/components/showBarcode.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";

export default {
  name: "InventorySerialTable",
  mixins: [CommonMixin],
  components: {
    showBarcode,
    Barcode,
    TableActivity,
  },
  props: {
    inventoryData: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    inbondDate: { type: String, default: null },
    inbondDoc: { type: String, default: null },
  },
  methods: {
    getColor(type) {
      if (type == "adjustment") {
        return "teal";
      } else if (type == "quotation") {
        return "orange";
      } else if (type == "invoice") {
        return "blue";
      } else if (type == "visit") {
        return "green";
      } else if (type == "product") {
        return "#24326d";
      } else if (type == "part") {
        return "#24326d";
      }
       else {
        return "cyan";
      }
    },
    getRoute(type) {
      if(type == 'product' || type == 'part'){
        return false;
      }
      if (type == "adjustment") {
        return "adjustment.detail";
      } else if (type == "quotation") {
        return "quotation.detail";
      } else if (type == "invoice") {
        return "invoice.detail";
      } else if (type == "visit") {
        return "visit.detail";
      } else {
        return "cyan";
      }
    },
  },
};
</script>
